import {BarChart3, RefreshCw} from "lucide-react";
import React from "react";
import { Select } from "./Select";

const StandingsView = ({
  standings,
  filters,
  onFilterChange,
  leagues,
  seasons,
  loading,
  onRefresh,
  t
}) => (
  <div className="space-y-6">
    {/* Standings Table */}
    <div className="border border-white/10 rounded-sm overflow-hidden bg-white/[0.02]">
      <div className="p-6 border-b border-white/10 flex items-center justify-between">
        <h2 className="text-2xl font-black uppercase tracking-tight text-white flex items-center gap-3">
          {t('League Standings')}
        </h2>
        {filters.league && filters.season && (
          <span className="text-[11px] font-mono uppercase tracking-widest text-gray-500">
            {filters.league} — {filters.season}
          </span>
        )}
      </div>

      {loading ? (
        <div className="p-12 text-center">
          <RefreshCw className="animate-spin mx-auto mb-4 text-white" size={32} />
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-400">
            {t('Loading standings...')}
          </p>
        </div>
      ) : standings.length === 0 ? (
        <div className="p-12 text-center">
          <BarChart3 className="mx-auto mb-4 text-gray-600" size={36} />
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-gray-500">
            {t('Select a league and season')}
          </p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-black/40">
            <tr>
              <th className="px-6 py-4 text-left text-[11px] font-mono uppercase tracking-widest text-gray-500">
                {t('POS')}
              </th>
              <th className="px-6 py-4 text-left text-[11px] font-mono uppercase tracking-widest text-gray-500">
                {t('TEAM')}
              </th>
              <th className="px-6 py-4 text-center text-[11px] font-mono uppercase tracking-widest text-gray-500">
                {t('GP')}
              </th>
              <th className="px-6 py-4 text-center text-[11px] font-mono uppercase tracking-widest text-gray-500">
                {t('W')}
              </th>
              <th className="px-6 py-4 text-center text-[11px] font-mono uppercase tracking-widest text-gray-500">
                {t('L')}
              </th>
              <th className="px-6 py-4 text-center text-[11px] font-mono uppercase tracking-widest text-gray-500">
                {t('SETS')}
              </th>
              <th className="px-6 py-4 text-center text-[11px] font-mono uppercase tracking-widest text-gray-500">
                {t('PTS')}
              </th>
            </tr>
            </thead>
            <tbody className="divide-y divide-white/10">
            {standings.map((team, index) => (
              <tr key={team.team?.id || index} className="hover:bg-white/5 transition-colors">
                <td className="px-6 py-4">
                  <div className={`w-10 h-10 rounded-sm flex items-center justify-center font-black text-sm uppercase tracking-wide ${
                    index < 4 ? 'bg-white/10 text-white' : 'bg-black text-gray-400 border border-white/10'
                  }`}>
                    {team.position || index + 1}
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="font-black text-white uppercase tracking-tight">
                    {team.team?.name || `Team ${index + 1}`}
                  </div>
                </td>
                <td className="px-6 py-4 text-center text-white font-semibold">{team.games?.played || 0}</td>
                <td className="px-6 py-4 text-center text-emerald-300 font-semibold">{team.games?.wins || 0}</td>
                <td className="px-6 py-4 text-center text-red-300 font-semibold">{team.games?.loses || 0}</td>
                <td className="px-6 py-4 text-center text-white">
                  {team.sets?.for || 0}-{team.sets?.against || 0}
                </td>
                <td className="px-6 py-4 text-center text-2xl font-black text-white">
                  {team.points || 0}
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
);

export default StandingsView;
